export default function createAriaLiveElement(extraClassNames: string[] = []): HTMLDivElement {
  const $el = document.createElement('div');
  $el.setAttribute('aria-live', 'polite');
  $el.setAttribute('aria-atomic', 'true');
  $el.classList.add('sr-only', ...extraClassNames);
  return $el;
}
